import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { FirstAuthn } from '../models/firstAuthn.model';
import { SaveSession } from '../models/saveSesion.model';
import { EvidenteRequest, EvidenteResponse } from '../models/validate.model';
import { BrokerService } from './broker.service';
import { ChangeService } from './change.service';
import { LoadingService } from './loading.service';
import { ModalService } from './modal.service';
import { SesionService } from './sesion.service';
import { ValidateService } from './validate.service';
import Fingerprintjs from '@Fingerprintjs/fingerprintjs';
import { DataLayerService } from './data-layer.service';
import { ErrorMessageService } from './error-message.service';
import { timer } from 'rxjs';
import { UtilitiesService } from './utilities.service';
import { Authorization } from '../models/Authorization.model';

declare var $: any;
declare var require: any;
const sha256 = require('js-sha256');

@Injectable({
  providedIn: 'root'
})

export class FormloginService {
  data: FirstAuthn;
  errorMessage: any;
  codeError:string="";
  product: string;
  logo: any;
  access_token: any;
  termsAndConditions: any;
  change: any;

  // Flujo registro
  registro: any;

  // Data Undia
  codUndia: any = null;

  // Nuevo SS0
  modelPaso1: any;
  modelPaso2: any;
  modelPaso2Fin: any;
  modelPaso3: any;
  modelPaso3Fin: any;
  modelPaso4: any;
  modelPaso4Fin: any;
  modelPaso5: any;
  paso1 = 1; //exist
  paso2 = 0; //first auth
  paso3 = 0; // 1=second auth - 2=verifyOTP(NOT_EVIDENTE)
  paso4 = 0;
  paso5 = 0;
  errorPaso1:boolean=false;
  //errorToken = 0;
  errorPaso2 = 0;
  errorPaso3 = 0;
  errorPaso5 = 0;
  dataQuestions: any;
  tipoDocumento1: any;
  documento1: any;
  password1: any;
  idLog: any;
  preguntaFinal: any;
  emailExist: any;
  mobileExist: any;
  nameExist: any;
  apellidoExist: any;
  navegador: any;
  ipAddress: string;
  listado: any;
  browserId: any;
  browAgentIe: any;
  browAgentFireFox: any;
  browAgentChrome: any;
  browAgentOpera: any;
  browAgentSafari: any;
  finalBrowserId: any;
  loaderPaso1 = 0;
  loaderRec = 0;
  recoveryQuestion: any;

  // Términos y condiciones
  terminos: any;

  // IAM
  changePassVar = 0;
  creaPass = 0;
  validaOTPBra = 0;
  loaderChange = 0;
  loaderOTPBra = 0;
  password: any;
  validatePassword: any;
  modelAddPassword: any;
  codigoOTPBra: any;
  //errorChangeContra = 0;
  //errorEnvioCodigo = 0;
  //errorChangeContraGral = 0;
  errorRegisterIam:boolean=false;
  errorContrasenaDiferente = 0;
  errorVerifyOTPBrasil = 0;
  errorVerifyOTPBrasil401 = 0;
  errorCodigo:boolean=false;
  loaderPaso2 = 0;
  errorPaso2Gral = 0;
  regValidacion: any;
  requierePreguntas: any;
  idTransactionOTP: any;
  errorBlocked = 0;
  errorOTPCode = 0;
  actualizaDatos = 0;
  loaderRecCorreo = 0;
  modelActualizacion: any;
  ingActualizaDatos = 0;
  loaderActu = 0;
  errorActuGral = 0;
  errorActuTime = 0;
  emailActu: any;
  celularActu: any;
  volverActu = 0;
  timerOTP:number=20;
  idTerm!:number;
  fechaExp!:Date;
  notHavePass=false;

  //timer otpBrazil
  
  seconds:number =5;
  source = timer(0, 1000);
  clock: any;
  sentOtp:boolean=false;
  //tyc
  authorizations: Authorization[] = [];
  authorizationsInit: Authorization[] = [];
  authorization: any;

  //errors
  errorProcess={
    exist: false,
    addPass:false,
    firstAuth:false
  }

  private singleExecutionSubscription: Subscription = new Subscription;

  constructor(
    private loading: LoadingService,
    private modal: ModalService,
    private sesion: SesionService,
    private broker: BrokerService,
    private router: Router,
    private cs: ChangeService,
    private http: HttpClient,
    private evidente: ValidateService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private dataLayerService: DataLayerService,
    public errorMsgService:ErrorMessageService,
    public utilities: UtilitiesService
  ) {

    this.data = {
      tipoDocumento: '1',
      documento: null,
      password: null
    };

    this.errorMessage = null;
    this.product = this.sesion.product;

    this.modelPaso1 = {
      tipoDocumento: '1',
      documento: '',
      country: environment.country,
      recaptcha: ''
    };

    this.modelPaso2 = {
      password: ''
    };

    this.modelPaso3 = {
      respuesta: ""
    };

    this.modelPaso4 = {
      questionConst: '',
      answer: ''
    };

    /*** Obtener nombre del navegador del usuario ***/
    var getBrowserInfo = function () {
      var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    };

    /*** FingerPrint ***/
    const fpPromise = Fingerprintjs.load()

    // Get the visitor identifier when you need it.
    fpPromise
      .then(fp => fp.get())
      .then(result => {
        // This is the visitor identifier:
        this.finalBrowserId = result.visitorId
        //console.log(visitorId)
      })
      .catch(error => console.error(error))

    this.navegador = getBrowserInfo();

    /*** Obtener la IP del usuario ***/
    //this.getIP();
    this.ipAddress = "123.123.123.123";

    /*** Obtener BrowserId del usuario. ***/
    /*this.browserId = navigator.userAgent.toLowerCase();
    this.browAgentIe = this.browserId.match(/msie ([\d.]+)/);
    this.browAgentFireFox = this.browserId.match(/firefox\/([\d.]+)/);
    this.browAgentChrome = this.browserId.match(/chrome\/([\d.]+)/);
    this.browAgentOpera = this.browserId.match(/opera.([\d.]+)/);
    this.browAgentSafari = this.browserId.match(/version\/([\d.]+).*safari/);

    if(this.browAgentIe != null){
      this.finalBrowserId = this.browAgentIe[1];
    }
    else if(this.browAgentFireFox != null){
      this.finalBrowserId = this.browAgentFireFox[1];
    }
    else if(this.browAgentChrome != null){
      this.finalBrowserId = this.browAgentChrome[1];
    }
    else if(this.browAgentOpera != null){
      this.finalBrowserId = this.browAgentOpera[1];
    }
    else if(this.browAgentSafari != null){
      this.finalBrowserId = this.browAgentSafari[1];
    }

    if(this.finalBrowserId == "" || this.finalBrowserId == undefined){
      this.finalBrowserId = "123.123.123.123";
    }*/

    this.modelPaso5 = {
      tipoDocumento: '',
      documento: '',
      password: '',
      clientId: this.sesion.codeApp,
      country: environment.country,
      questionConst: '',
      question: '',
      answer: '',
      location: "-",
      idExplorer: this.navegador
    };

    this.recoveryQuestion = {
      tipoDocumento: '',
      documento: '',
      clientId: this.sesion.codeApp,
      country: environment.country,
      recoveryOption: "QUESTION"
    };

    this.emailExist = '';

    this.modelActualizacion = {
      idSession: "NA",
      country: environment.country,
      autogestion: true,
    }
  }

  /*** Consulta si el usuario existe en nuestra Base de datos ***/
  procesoPaso1(data: NgForm) {
    this.errorPaso1 = false;
    //this.errorToken = 0;
    this.loaderPaso1 = 1;
    this.tipoDocumento1 = this.modelPaso1.tipoDocumento;
    this.documento1 = this.modelPaso1.documento;

    this.recoveryQuestion.tipoDocumento = this.modelPaso1.tipoDocumento;
    this.recoveryQuestion.documento = this.modelPaso1.documento;

    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service
      .execute("CaptchaUserExist")
      .subscribe({
        next: (token: string) => {
          this.modelPaso1.recaptcha = token;
          this.broker.consultUser(this.modelPaso1).subscribe({
            next: (respuesta1: any) => {
              
              if (respuesta1.userExists == true) {
                this.loaderPaso1 = 0;
                this.paso1 = 0;
                this.paso2 = 1;
                this.emailExist = respuesta1.email;
              }
            },
            error: (error: any) => {
              this.loaderPaso1 = 0;

              switch (error.status) {
                case 409:
                  this.emailExist = error.error.email;
                  this.sesion.tipo = this.modelPaso1.tipoDocumento;
                  this.sesion.numDoc = this.modelPaso1.documento;

                  if (this.modelPaso1.tipoDocumento == 1) {
                    this.sesion.tipoDoc = "cédula de ciudadanía";
                  }
                  else if (this.modelPaso1.tipoDocumento == 4) {
                    this.sesion.tipoDoc = "cédula de extranjería";
                  }
                  else if (this.modelPaso1.tipoDocumento == 9) {
                    this.sesion.tipoDoc = "permiso especial de permanencia";
                  }

                  switch (error.error.code) {
                    case 'EXISTS-IAM001':
                      $('#changePass').modal('show');
                      break;

                    case 'CALL_EXPERIAN':
                      $('#callExperian').modal('show');
                      break;

                    case 'EXISTS-ECS001':
                      this.router.navigate(['/registro'], { queryParams: { product: this.sesion.product } });
                      break;
                    
                    default:
                      this.errorMsgService.setErrorMessage("EXIST",error.error.code);
                      this.errorPaso1=true;
                  }
                  break;

                default:
                  this.errorMsgService.setErrorMessage("EXIST",error.status.toString());
                  this.errorPaso1=true;
                  break;
              }
            }
          });   
        },
        error: () => {
          this.errorMsgService.setErrorMessage("EXIST","EXIST-ECS002");
          this.errorPaso1=true;
        }
      });
  }

  /*** Cierra modal de aviso de cambio de contraseña ***/
  cierraMod() {
    this.paso1 = 0;
    this.changePassVar = 1;
    this.creaPass = 1;
  }

  /*** Cambiar contraseña IAM ***/
  cambiarContrasenaIAM(datos: NgForm) {
    this.loaderChange = 1;
    this.errorRegisterIam=false;
    this.errorContrasenaDiferente = 0;
    if(this.validatePassword == this.password){
      if(!this.notHavePass){
        this.broker.registerUserIam(this.modelPaso1).subscribe((respRegister: any) => {
          this.loaderChange = 0;
          this.creaPass = 0;
          this.validaOTPBra = 1;
        },
          (error) => {
            this.loaderChange = 0;
            this.errorRegisterIam=true;
            this.errorMsgService.setErrorMessage("REGISTER",error.error.code);
          });
      }else{
        const dataMail = {
          "documentType": parseInt(this.tipoDocumento1),
          "idNumber": this.documento1,
          "clientId": this.sesion.codeApp,
          "country": environment.country
        }
    
        this.broker.asignPasswordIAM( dataMail ).subscribe( (resp: any) => {
          this.loaderChange = 0;
          this.creaPass = 0;
          this.validaOTPBra = 1;
        },
        (error) => {
          this.loaderChange = 0;
            this.errorRegisterIam=true;
            this.errorMsgService.setErrorMessage("REGISTER",error.error.code);
        }); 
        this.notHavePass=false;
      }
    }else{
      this.loaderChange = 0;
      this.errorContrasenaDiferente = 1;
    }
  }

  /*** Valida el código que introduce el usuario para realizar el cambio de contraseña. ***/
  verifyOTPBrasil(repeat:boolean) {
    this.loaderOTPBra = 1;

    this.modelAddPassword = {
      validationCode: this.codigoOTPBra,
      newPassword: this.password,
      tipoDocumento: this.tipoDocumento1,
      documento: this.documento1,
      sendEmailWelcome: false
    };

    this.broker.addPasswordExist(this.modelAddPassword).subscribe((respRegister: any) => {
      this.loaderOTPBra = 0;
      this.errorCodigo=false;
      $('#contrasenaCambiada').modal('show');
      //GA4 - validate_code
      this.dataLayerService.dl_eventoGA4_login( 'validate_code', this.sesion.product );
    },
      (error) => {
        
        this.loaderOTPBra = 0;
        this.errorCodigo=true;
        switch (error.status) {
          case 409:

            switch (error.error.code) {
              case 'ADDPASS-IAM008':
                this.errorMsgService.setErrorMessage("ADD_PASS",error.error.code);
                
                break;
              default:
                this.errorMsgService.setErrorMessage("ADD_PASS",error.error.code);
            }
            break;

          default:
            this.errorMsgService.setErrorMessage("ADD_PASS",error.status.toString());
            break;
        }
      });
  }

  /*** Cierra modal de cambio de contraseña exitoso ***/
  cierraModCambio() {
    this.changePassVar = 0;
    this.validaOTPBra = 0;
    this.paso1 = 1;
  }

  /*** Inicia sesión con la primera autenticación. ***/
  procesoPaso2(valid: boolean | null) {
    this.password1 = this.modelPaso2.password;
    this.errorPaso2 == 0;
    this.errorBlocked == 0;
    this.errorOTPCode == 0;
    this.errorPaso2Gral == 0;
    this.modelPaso2Fin = {
      tipoDocumento: this.tipoDocumento1,
      documento: this.documento1,
      password: this.modelPaso2.password,
      clientId: this.sesion.codeApp,
      country: environment.country,
      idExplorer: this.finalBrowserId,
      newFirstAuthn: true,
      nameExplorer: this.navegador,
      ipAddress: this.ipAddress,
      location: "-",
      justEvidente: false
    };

    if (valid) {
      this.evidente.modeloLogin = this.modelPaso2Fin;
      this.loaderPaso2 = 1;
      this.callFirstAuthn(this.modelPaso2Fin);
    }
    this.logo = this.sesion.logo;
  }

  /*** Llamado al servicio de firstAuthn ***/
  callFirstAuthn(modelo: any) {
    this.broker.firstAuthn(modelo).subscribe((respuesta2: any) => {
      if (respuesta2.idSession != "") {
        this.getTermsConditions().then((auth: Authorization[]) => {
          this.loaderPaso2 = 0;
          this.loading.close();
          if (this.validateAccept(auth)) {
            this.sesion.idSessionTemp = respuesta2.idSession;
            this.router.navigate(['/terminos-condiciones'], { queryParams: { product: this.sesion.product } });
          } else {
            this.sesion.setCookie(respuesta2.idSession);
            this.ingresoNuevo();
          }
        }).catch(() => {
          this.loaderPaso2 = 0;
          this.errorPaso2Gral = 1;
          this.loading.close();
        });

      }
    },
      (error) => {
        this.loaderPaso2 = 0;

        switch (error.status) {
          case 429:
            this.changePassVar = 1;
            this.validaOTPBra = 1;
            this.paso3 = 1;
            this.idLog = error.error.id;
            this.startTimer();
          break;
          case 409:
            this.errorMsgService.setErrorMessage("LOGIN",error.error.code);
            switch (error.error.userState) {
              case 'SECOND_AUTHN':
                this.changePassVar = 1;
                this.validaOTPBra = 1;
                this.paso3 = 1;
                this.idLog = error.error.id;
                this.startTimer();
                break;

              case 'NOT_EVIDENTE':
                if (this.singleExecutionSubscription) {
                  this.singleExecutionSubscription.unsubscribe();
                }
                this.singleExecutionSubscription = this.recaptchaV3Service
                  .execute("CaptchaGenerateOTP")
                  .subscribe({
                    next: (token: string) => {
                      const request = {
                        identificacion: this.documento1,
                        tipoIdentificacion: this.tipoDocumento1,
                        // primerApellido: error.error.apellido,
                        // nombres: error.error.nombre,
                        // telefono: error.error.phone,
                        fechaExpedicion: '1202156600',
                        captcha: token
                      }
                      this.iniciarEvidenteOTP(request);
                    },
                    error: () => {
                      // Error.
                    }
                  });
                break;

              case 'NOT_HAVE_PASS':
                this.paso2 = 0;
                this.notHavePass = true;
                $('#changePass').modal('show');
                break;

              case 'USER_BLOCKED_30':
                //LOGINIAM062
                this.errorBlocked = 1;
                break;

              case 'ERROR_OTP_CODE':
                this.errorOTPCode = 1;
                break;

              case 'NOT_VALID':
                this.errorPaso2 = 1;
                break;

              default:
                $('#callExperian').modal('show');
                break;
            }
            break;

          case 401:
            //TODO: Problemas de conexion
            this.errorPaso2 = 1;
            break;

          default:
            //TODO: Error muy generico
            this.errorPaso2Gral = 1;
            this.errorMsgService.setErrorMessage("LOGIN",error.status.toString());
            break;
        }
      });
  }
  

  validateAccept(authorizations: Authorization[]): boolean {
    let status: boolean[] = [];
    authorizations.forEach((a: Authorization) => {
      if (a.flagOptional === false && a.status === false) {
        status.push(true);
      }
    });

    if (status.length == 0) {
      return false;
    } else if (status.every(s => s === true)) {
      return true;
    } else {
      return false;
    }
  }

  /*** Registra su equipo seguro para iniciar sesión. ***/
  secondAuthn(repeat:boolean) {
    this.loaderOTPBra = 1;

    this.modelPaso3Fin = {
      answer: this.codigoOTPBra,
      clientId: this.sesion.codeApp,
      country: environment.country,
      id: this.idLog,
      idExplorer: this.finalBrowserId,
      password: this.password1
    }

    this.broker.secondAuthn(this.modelPaso3Fin).subscribe((respuesta3: any) => {
      if (respuesta3.idSession != "") {
        this.getTermsConditions().then((auth: Authorization[]) => {
          this.loaderOTPBra = 0;
          if (this.validateAccept(auth)) {
            this.sesion.idSessionTemp = respuesta3.idSession;
            this.router.navigate(['/terminos-condiciones'], { queryParams: { product: this.sesion.product } });
          } else {
            this.dataLayerService.dl_eventoGA4_login('validate_code', this.sesion.product);
            this.sesion.setCookie(respuesta3.idSession);
            this.ingresoNuevo();
          }
        }).catch(() => {
          this.loaderOTPBra = 0;
          this.errorPaso2Gral = 1;
        });
      }
    },
      (error) => {
        this.loaderOTPBra = 0;

        switch (error.status) {
          case 401:
            this.errorVerifyOTPBrasil401 = 1;
            break;

          default:
            if(repeat){
              setTimeout(() => {
                this.secondAuthn(false);
                }, 500);
            }else{
              this.errorVerifyOTPBrasil = 1;
            }
            break;
        }
      });
  }

  /*** Secuencia de comandos para iniciar la sesión cuando las credenciales ya fueron validadas */
  ingresoNuevo() {
    // GA4 - login
    this.dataLayerService.dl_eventoGA4_login( 'login', this.sesion.product );
    if (this.sesion.product === 'bc') {
        window.location.href = this.utilities.getUrlProduct('bc');      
    }
    if (this.sesion.product === 'midc') {
      switch (this.change) {
        case 'titulos':
          this.router.navigate(['/oneshot/payments'], { queryParams: { product: this.sesion.product } });
          break;
        case 'undia':
          this.cs.activarUndia(this.codUndia);
          break;
        default:
          this.redirectLogin();
          break;
      }
    }
    if (this.sesion.product === 'pntd') {
      window.location.href = this.utilities.getUrlProduct('pntd');
    }
    if (this.sesion.product === 'vrf') {
      window.location.href = this.utilities.getUrlProduct('vrf');;
    }
    if (this.sesion.product === 'os') {
      this.router.navigate(['/oneshot/payments'], { queryParams: { product: this.sesion.product } });
    }
  }

  /*** Iniciar evidente OTP - IAM. ***/
  iniciarEvidenteOTP(evidenteValidacion: EvidenteRequest) {
    this.loading.open('Por favor espera un momento...', 'Estamos validando tus datos.');

    const body = JSON.stringify(evidenteValidacion);
    this.broker.validateOTP(body).subscribe((resp: any) => {
      if (resp.resultado != undefined) {
        this.errorVerify(resp.resultado);
      }
      else {
        this.regValidacion = resp.DatosCuestionario.regValidacion;
        if (resp.ResultadoValidacion.numeroValido === 'true') {
          this.loading.close();
          this.requierePreguntas = resp.ResultadoGeneracion.requiereCuestionario;
          this.idTransactionOTP = resp.ResultadoGeneracion.idTransaccionOTP;
          this.paso2 = 0;
          this.changePassVar = 1;
          this.validaOTPBra = 1;
          this.paso3 = 2;
        } else {
          if (this.singleExecutionSubscription) {
            this.singleExecutionSubscription.unsubscribe();
          }
          this.singleExecutionSubscription = this.recaptchaV3Service
            .execute("CaptchaGenerateOTP")
            .subscribe(
              (token) => {
                const preguntas = {
                  identificacion: evidenteValidacion.identificacion,
                  tipoId: evidenteValidacion.tipoIdentificacion,
                  regValidacion: this.regValidacion,
                  parametro: environment.parametroOTP,
                  producto: "010",
                  captcha: token
                }
                this.sesion.autogestion = 0;
                this.evidente.registroCuestionarioOTP(preguntas);
              },
              (error) => {
                // Error.
              }
            );
        }
      }
    },
      (error) => {
        this.validateUser(evidenteValidacion, false);
      });
  }

  /*** Evidente preguntas - No OTP. ***/
  validateUser(request: EvidenteRequest, autogestion: boolean) {
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service
      .execute(autogestion ? "CaptchaAutoGestion" : "CaptchaGenerateEvidenteII")
      .subscribe(
        (token) => {
          request.captcha = token;
          request.parametro = environment.parametriaAutoGestion;
          const body = JSON.stringify(request);
          this.sesion.autogestion = autogestion ? 1 : 0;
          this.broker.validateUser(body).subscribe((resp: any) => {
            this.loaderRecCorreo = 0;
            if (resp.resultado === '01') {
              this.evidente.preguntasEvidente(request, resp);
            } else {
              this.errorVerify(resp.resultado);
            }
          },
            (error) => {
              this.errorVerify();
              this.loaderRecCorreo = 0;
            });
        },
        (error) => {
          // Error.
        }
      );
  }

  /*** Modal de errores de evidente. ***/
  errorVerify(resultado: any = null) {
    this.loaderRecCorreo = 0;
    this.loading.close();
    switch (resultado) {
      case '05':
        this.modal.open(
          'No podemos generar tu historia de crédito',
          // tslint:disable-next-line: max-line-length
          '<p class="mt-3 text-center">Tu cédula está registrada en nuestra base de datos, sin embargo, no cuentas con ninguna obligación abierta y/o vigente en tu <b>Historia de Crédito</b> o ninguna entidad ha reportado información comercial a la fecha como para generarte un reporte de crédito.</span></p>',
          'assets/images/backgrounds/No_data.svg',
          true,
          '',
          'Entendido',
          'modal-confirm'
        );
        break;
      case '09':
        this.modal.open(
          'Has superado tu límite de intentos permitidos',
          // tslint:disable-next-line: max-line-length
          '<p class="mt-3 text-center">Por favor vuelve a intentarlo nuevamente mañana.</span></p>',
          'assets/images/backgrounds/No_data.svg',
          true,
          '',
          'Entendido',
          'modal-confirm'
        );
        break;
        case '06':
        case '07':
        this.modal.open(
          'Error validando tu identidad.',
          // tslint:disable-next-line: max-line-length
          '<p class="mt-3 text-center">Revisa que los datos ingresados coincidan de forma correcta, en caso de no poder continuar puedes comunicarte mediante nuestro canal de atención <b>Email: <a href="mailto:servicioalciudadano@experian.com">servicioalciudadano@experian.com</a></b></p>',
          'assets/images/backgrounds/No_coincide.svg',
          true,
          '',
          'Entendido',
          'modal-confirm'
        );
        break;
      default:
        this.modal.open(
          'Error validando tu identidad.',
          // tslint:disable-next-line: max-line-length
          '<p class="mt-3 text-center">Hemos presentado un error validando tu identidad, por favor intentalo más tarde.</span></p>',
          'assets/images/backgrounds/No_coincide.svg',
          true,
          '',
          'Entendido',
          'modal-confirm'
        );
        break;
    }
  }

  /*** Valida código de evidente OTP ***/
  verifyOTP() {
    this.loading.open('Por favor espera un momento...', 'Estamos validando tus datos.');
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service
      .execute("CaptchaVerifyOTP")
      .subscribe(
        (token) => {
          const shaCode = sha256(this.codigoOTPBra);
          const body = {
            identificacion: this.documento1,
            tipoIdentificacion: this.tipoDocumento1,
            regValidacion: this.regValidacion,
            idTransaccionOTP: this.idTransactionOTP,
            codigoOTP: shaCode,
            captcha: token
          };
          this.broker.verifyOTP(body).subscribe((response: any) => {
            if (response.resultadoValidacion == '1') {
              if (this.requierePreguntas == "true") {
                
                if (this.singleExecutionSubscription) {
                  this.singleExecutionSubscription.unsubscribe();
                }
                this.singleExecutionSubscription = this.recaptchaV3Service
                  .execute("CaptchaGenerateOTP")
                  .subscribe(
                    (token) => {
                      const preguntas = {
                        identificacion: this.documento1,
                        tipoId: this.tipoDocumento1,
                        regValidacion: this.regValidacion,
                        parametro: environment.parametroOTP,
                        producto: "010",
                        captcha: token
                      }
                      this.evidente.registroCuestionarioOTP(preguntas);
                    },
                    (error) => {
                      // Error.
                    }
                  );
              } else {
                this.loading.close();
                this.modelPaso2Fin.justEvidente = true;
                this.callFirstAuthn(this.modelPaso2Fin);
              }
            } else if (response.resultadoValidacion == '6') {
              // codigo expirado volver a enviar codigo
              this.loading.close();
              this.modal.open(
                'No pudimos validar tu identidad satisfactoriamente.',
                '<p>Tu codigo de validación ha expirado vuelve a intentarlo.</p>',
                'assets/images/icons/bad.svg',
                true,
                '.',
                'Volver a intentar',
                'modal-error'
              );
              // this.paso4 = 0;
              // this.paso5 = 1;
            } else if (response.resultadoValidacion != '1') {
              this.loading.close();
              // modal salir o volver a intentar
              this.modal.open(
                'No pudimos validar tu identidad satisfactoriamente.',
                '<p>Tenemos problemas para validar tu identidad.</p>',
                'assets/images/icons/bad.svg',
                true,
                '.',
                'Intentar nuevamente',
                'modal-error'
              );
              // this.paso4 = 0;
              // this.paso5 = 1;
            }
          }, error => {
            this.loading.close();
            this.modal.open(
              'No pudimos validar tu identidad satisfactoriamente.',
              '<p>Tenemos problemas para validar tu identidad.</p>',
              'assets/images/icons/bad.svg',
              true,
              '.',
              'Intentar nuevamente',
              'modal-error'
            );
            // this.paso4 = 1;
            // this.paso5 = 0;
          });
        },
        (error) => {
          // Error.
        }
      );
  }

  /*** Función que redirige al login si el registro fue exitoso. ***/
  irLogin() {
    this.router.navigate(['/login'], { queryParams: { product: this.sesion.product } });
    this.changePassVar = 0;
    this.ingActualizaDatos = 0;
  }

  /*** Función para ir a recuperación de correo electrónico. ***/
  recCorreo() {
    this.validaOTPBra = 0;
    this.actualizaDatos = 1;
  }

  /*** Función que inicia el evidente para la posterior actualización de datos (correo y celular). ***/
  iniRecCorreo() {
    let strDate:string = this.fechaExp.toISOString().slice(0,10)
    console.log(strDate)
    strDate += 'T00:00:00.000Z'
    this.fechaExp.toString
    this.loaderRecCorreo = 1;
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service
      .execute("AutoGestion")
      .subscribe(
        (token) => {
          const request = {
            identificacion: this.documento1,
            tipoIdentificacion: this.tipoDocumento1,
            primerApellido: this.apellidoExist,
            nombres: this.nameExist,
            fechaExpedicion: ((new Date(strDate)).valueOf()).toString(),
            captcha: token
          }
          this.validateUser(request, true);
        },
        (error) => {
          // Error.
        }
      );
  }

  /*** Función para cancelar el inicio de la actualización de datos. ***/
  volverCodigo() {
    this.actualizaDatos = 0;
    this.ingActualizaDatos = 0;
    this.validaOTPBra = 1;
  }

  /*** Función para cancelar el inicio de la actualización de datos y volver a al recuperación de contraseña. ***/
  volverRecPass() {
    this.router.navigate(['/recovery'], { queryParams: { product: this.sesion.product } });
    this.changePassVar = 0;
    this.actualizaDatos = 0;
  }

  /*** Función que actualiza la información. ***/
  actualizacion() {
    this.loaderActu = 1;
    this.modelActualizacion.typeDocument = this.tipoDocumento1,
      this.modelActualizacion.idNumber = this.documento1

    if (this.emailActu != "") {
      this.modelActualizacion.email = this.emailActu;
    }

    if (this.celularActu != "") {
      this.modelActualizacion.cellPhone = this.celularActu;
    }

    this.broker.updateProfile(this.modelActualizacion).subscribe((resActualizacion: any) => {
      this.loaderActu = 0;
      $('#confirmacion').modal('show');
    },
      (error) => {
        this.loaderActu = 0;

        switch (error.status) {
          case 403:
            this.errorActuTime = 1;
            break;

          case 500:
            $('#errorActualizacion').modal('show');
            break;

          default:
            this.errorActuGral = 1;
            break;
        }
      });
  }

  /*** Función para cerrar el modal de confirmación de actualización de datos. ***/
  cerrarConfirmacion() {
    this.changePassVar = 0;
    this.ingActualizaDatos = 0;
  }


  ingresar(datos: NgForm) {
    if (datos.valid) {
      this.errorMessage = null;
      this.loading.open('Por favor espera un momento ...', 'Estamos validando tu identidad');

      // tslint:disable-next-line: radix
      datos.value.tipoDocumento = parseInt(datos.value.tipoDocumento);
      datos.value.clientId = this.sesion.codeApp;

      this.firstAuth(datos.value, false);
    } else {
      this.errorMessage = 'Inicio de sesión fallido, datos no válidos';
    }
  }

  firstAuth(data: FirstAuthn, registro: boolean) {
    this.registro = registro;

    this.broker.firstAuthn(data).subscribe((resp: any) => {
      if (resp.active) {
        this.access_token = resp.token;
        this.saveSession();
      } else {
        this.router.navigate(['/error'], { queryParams: { product: this.sesion.product }, queryParamsHandling: 'preserve' });
      }
    },
      (error) => {
        this.cs.recaptcha = null;
        this.loading.close();

        switch (error.status) {
          case 409:
            switch (error.error.userState) {
              case 'NOT_EXIST':
                this.modal.open(
                  'Aún no eres un usuario registrado.',
                  // tslint:disable-next-line: max-line-length
                  '<p class="mt-3 text-center">Te invitamos a <span class="link">registrarte ahora</span> y empezar a tomar el control de tus datos personales y tu información financieria.</p>',
                  'assets/images/icons/No_registrado_mobile.svg',
                  true,
                  '/registro?product=' + this.sesion.product,
                  'Registrarme',
                  'modal-confirm'
                );
                break;
              case 'RECOVERY_PASS':
                this.modal.open(
                  'Tu usuario está bloqueado',
                  // tslint:disable-next-line: max-line-length
                  '<p class="mt-3 text-center">Para poder acceder a tu cuenta de Midatacrédito debes <span class="link">cambiar tu contraseña</span>, el correo que tenemos vinculado es: <br><br> <span class="link">' + error.error.correo + '</span><br><br>Te invitamos a recuperarla a continuación.</p>',
                  'assets/images/icons/Recuperar_contraseña_mobile.svg',
                  true,
                  '/recovery?product=' + this.sesion.product,
                  'Recuperar contraseña',
                  'modal-confirm'
                );
                break;
              case 'CALL_EXPERIAN':
                this.modal.open(
                  'Tu usuario está inactivo',
                  // tslint:disable-next-line: max-line-length
                  '<p class="mt-3 text-center">Para poder acceder a tu cuenta de Midatacredito debes comunicarte con nuestra línea de atención: <span class="link">(601)7430606​ en Bogotá, 018000 947 030 Línea Nacional. </span></p>',
                  'assets/images/icons/Inactivo_mobile.svg',
                  true,
                  '',
                  'Entendido',
                  'modal-confirm'
                );
                break;
              default:
                this.modal.open(
                  'Tu usuario está inactivo',
                  // tslint:disable-next-line: max-line-length
                  '<p class="mt-3 text-center">Para poder acceder a tu cuenta de Midatacredito debes comunicarte con nuestra línea de atención: <span class="link">(601)7430606​ en Bogotá, 018000 947 030 Línea Nacional. </span></p>',
                  'assets/images/icons/Inactivo_mobile.svg',
                  true,
                  '',
                  'Entendido',
                  'modal-confirm'
                );
                break;
            }
            break;
          case 401:
            this.modal.open(
              'Los datos que ingresaste no coinciden.',
              // tslint:disable-next-line: max-line-length
              '<p class="mt-3 text-center">Algo está mal con los datos que ingresaste, por favor <span class="link">intentalo de nuevo</span> o en caso de no recordar tu contraseña <span class="link">cambiala aquí</span> ingresando tu correo y tu documento de identidad.</p>',
              'assets/images/icons/Recuperar_contraseña_mobile.svg',
              true,
              '/recovery?product=' + this.sesion.product,
              'Recuperar contraseña',
              'modal-confirm',
              '- Intentar de nuevo -'
            );
            break;
          default:
            this.errorMessage = 'Inicio de sesión fallido, datos no válidos';
            break;
        }
      }
    );
  }

  saveSession() {
    if (!this.access_token) {
      this.loading.close();
      this.modal.close();
      this.router.navigate(['/error'], { queryParams: { product: this.sesion.product } });
    } else {
      this.broker.saveSession(this.access_token).subscribe((resp: any) => {
        this.access_token = null;
        this.sesion.setCookie(resp.idSession);

        if (this.sesion.product === 'bc') {
          this.loading.close();
          this.modal.close();
          window.location.href =  this.utilities.getUrlProduct('bc');
        }
        if (this.sesion.product === 'midc') {

          switch (this.change) {
            case 'titulos':
              this.loading.close();
              this.modal.close();
              this.router.navigate(['/oneshot/payments'], { queryParams: { product: this.sesion.product } });
              break;
            case 'undia':
              this.loading.close();
              this.modal.close();
              this.cs.activarUndia(this.codUndia);
              break;
            default:
              //this.mostrarTerminos();
              this.redirectLogin();
              break;
          }
        }
        if (this.sesion.product === 'pntd') {
          window.location.href = this.utilities.getUrlProduct('pntd');
        }
        if (this.sesion.product === 'vrf') {
          window.location.href = this.utilities.getUrlProduct('vrf');
        }
        if (this.sesion.product === 'os') {
          window.location.href = this.utilities.getUrlProduct('midc');
        }
      },
        (error) => {
          this.cs.recaptcha = null;
          this.loading.close();
          this.router.navigate(['/error'], { queryParams: { product: this.sesion.product } });
        }
      );
    }
  }

  mostrarTerminos() {
    $(document).ready(function () {
      $('#terminosModal').modal({ backdrop: 'static', keyboard: false })
    });

    // if(this.terminos == ""){
    //   $( document ).ready(function() {
    //     $('#terminosModal').modal({backdrop: 'static', keyboard: false})
    //   });
    // }
    // else {
    //   this.redirectLogin();
    // }
  }

  saveTerms() {
    const data2 = {
      session: this.sesion.cookieValue,
      termCondition: 4
    };

    this.broker.guardarTerminos(data2).subscribe((resultado: any) => {
      //console.log("respondió 200", resultado);
      this.redirectLogin();
    }, error => {
      //console.log("Este es el error", error);
      this.redirectLogin();
    })
  }

  dontAccept() {
    this.sesion.closeSession();
    window.location.href = this.utilities.getUrlProduct('midc');
  }

  redirectLogin() {
    if (this.sesion.redirect) {
      this.sesion.deleteCookieServices('REDIRECT', environment.domain);
      window.location.href = this.utilities.getUrlProduct('midc') + this.sesion.redirect;
    } else {
      window.location.href = this.utilities.getUrlProduct('midc');
    }
  }

  validateSession() {
    this.broker.validationSession().subscribe((resp: any) => {
      this.sesion.user = resp;
    },
      (error) => {
        this.sesion.closeSession();
      }
    );
  }

  deleteSession() {
    this.broker.cerrarSesion().subscribe((res: any) => {
      this.sesion.closeSession();
    }, err => {
      this.sesion.closeSession();
    });
  }

  listarPreguntas() {
    this.dataQuestions = {
      clientId: this.sesion.codeApp,
      country: environment.country
    };

    this.broker.questionList(this.dataQuestions).subscribe((preguntas: any) => {
      this.listado = preguntas;
    },
      (error) => {

      });
  }
  
  goStart(){
    this.changePassVar = 0;
    this.actualizaDatos = 0;
    this.ingActualizaDatos = 0;
    this.paso1=1;
    this.paso2=0;
    this.evidente.withEvident= false;
    this.loaderRecCorreo=0;
    this.router.navigate(['/login'], { queryParams: {product : this.sesion.product}});
  }
  recuperacionCorreo() {
    this.changePassVar = 1;
    this.actualizaDatos = 1;
    this.volverActu = 1;
    this.loaderRecCorreo = 0;
    this.ingActualizaDatos =0;
    this.router.navigate(['/login'], { queryParams: {product : this.sesion.product}});
  }
  

  showDate(end:any,now:any){
    let distance = end - now;
    if(distance >= 0){
      let _second = 1000;
      let _minute = _second * 60;
      this.seconds = Math.floor((distance % _minute) / _second);
    }else{
      this.seconds = this.timerOTP;
      this.sentOtp=true;
      this.clock.unsubscribe();
    }
  }

  startTimer(){
    this.sentOtp=false;
    let end = new Date();
    end.setSeconds(end.getSeconds()+this.timerOTP)
    this.clock = this.source.subscribe(t => {
      let now = new Date();
      this.showDate(end,now);
    });
  }
  loadParameters(){
    this.broker.loadParameters('INIT').subscribe(
      {
        next: (data: any) => {
          this.timerOTP=data.parameters.timeOutOTP;
          this.idTerm=data.parameters.idTerm;
        },
        error: (error) => {
          this.timerOTP=20;
        }
      }
      
    );
  }

  getTermsConditions() {
    return new Promise<Authorization[]>((resolve) => {
      const observableTermsConditions = this.broker.getTermsConditions(this.modelPaso1.tipoDocumento, this.modelPaso1.documento, "");
      observableTermsConditions.subscribe({
        next: (resp: Authorization[]) => {
          this.setAuthorization(resp);
          resolve(resp);
        }, error: () => { }
      });
    });
  }

  setAuthorization(resp: Authorization[]) {
    this.authorizationsInit = resp.filter(a => a.status == false);
    this.authorizations = resp;
  }
  
}
